import { createContext, useContext, useMemo, useState } from 'react';
import PropTypes from 'prop-types'

const ClientContext = createContext();

export const ClientProvider = ({ children }) => {
    const [clients, setClients] = useState([]);
    // You can have a single state object for user attributes
    const [client, setClient] = useState({});
    const [selectedClient, setSelectedClient] = useState({});
  
  
  
    const setClientAttributes = (attributes) => {
      // Merge the new attributes with the existing ones
      setClient((prevClient) => ({ ...prevClient, ...attributes }));
     

    };
    // Utilisation de useMemo pour mémoïser l'objet `value`
    const value = useMemo(() => ({
      clients,
      setClients,
      client,
      setClientAttributes,
      selectedClient,
      setSelectedClient
  }), [clients, client, selectedClient]);

  
    return (
      <ClientContext.Provider value={value}>
        {children}
      </ClientContext.Provider>
    );
  };
  ClientProvider.propTypes={
    children:PropTypes.node.isRequired
  }
  
  export const useClient = () => {
    return useContext(ClientContext);
  };